import { useEffect, useRef, useState } from 'react'
import { Billing } from '../../interface/interfaces'
import { Autocomplete } from "@react-google-maps/api";
import './addbilling.scss'
import LoaderBtn from '../LoaderBtn/LoaderBtn';
import { addBillingInfo } from '../../api/requests';
import { useNotification } from '../../context/NotificationContext';
import { useNavigate } from 'react-router-dom';
import 'animate.css'
import { allCountries } from 'country-telephone-data';

const AddBilling = () => {
    const navigate = useNavigate()
    const { notify } = useNotification()
    const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);


    function getDialCode(countryName: string): string | undefined {
        const match = allCountries.find(
            (country) => country.name.toLowerCase() === countryName.toLowerCase()
        );

        return match ? `+${match.dialCode}` : undefined;
    }

    // const addressBox = useRef<HTMLDivElement>(null)

    useEffect(() => {

        const pacContainers = document.querySelectorAll('.pac-container') as NodeListOf<HTMLElement>;
        pacContainers.forEach((pac) => {
            pac.style.borderTop = 'none';
        });

    }, []);

    const [billing, setBilling] = useState<Billing>({
        id: '',
        firstname: '',
        lastname: '',
        phone: '',
        address: '',
        country: '',
        state: '',
        city: '',
        zipcode: '',
        countrycode: ''
    })

    const [isSaving, setIsSaving] = useState(false)


    const handleInput = (value: string, name: string) => {
        setBilling((prev) => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleDialCode = (value: string) => {
        const formattedValue = value.trim().startsWith('+') ? value.trim() : `+${value.trim()}`;
        setBilling(prev => ({ ...prev, countrycode: formattedValue }));
    };

    const handlePlaceChanged = () => {
        const place = autocompleteRef.current?.getPlace();
        if (!place || !place.address_components) return;

        const getComponent = (types: string[]) =>
            place.address_components?.find(c => types.some(t => c.types.includes(t)))?.long_name || "";

        const address = place.formatted_address || "";
        const city = getComponent(["locality", "administrative_area_level_2"]);
        const state = getComponent(["administrative_area_level_1"]);
        const country = getComponent(["country"]);
        const zip = getComponent(["postal_code"]);

        setBilling(prev => ({
            ...prev,
            address,
            city,
            state,
            country,
            zipcode: zip,
            countrycode: getDialCode(country) || ''
        }));

        // This line closes the dropdown
        inputRef.current?.blur();
    };


    const isAllInputValid = (data: Billing) => {

        const requiredFields = ['firstname', 'lastname', 'phone', 'address', 'country', 'state', 'city', 'zipcode'];

        return requiredFields.every((field) => {
            const value = (data as any)[field];
            return typeof value === 'string' && value.trim() !== '';
        });
    };


    function isValidPhoneNumber(phone: string) {
        return /^\+?[0-9\s-]{10,15}$/.test(phone);
    }



    const hasAnyCountryCode = (phone: string): boolean => {
        return /^\+\d{1,4}/.test(phone.trim());
    };


    const saveFunc = async () => {
        try {

            setIsSaving(true)

            if (!isAllInputValid(billing)) {
                throw Error('Please fill in all required fields')
            }

           


            let fullphone = (`${billing.countrycode}${billing.phone}`).trim()




            if (!isValidPhoneNumber(fullphone)) throw Error('Please enter valid phone number')

            if (!hasAnyCountryCode(fullphone)) throw Error('Please add country code prefix to phone number')

            if(billing.countrycode === '+'){
               throw Error('Please add country code prefix to phone number')
            }




            let billingInfo = {
                name: `${billing.firstname} ${billing.lastname}`,
                billing_address: billing.address,
                billing_city: billing.city,
                billing_state: billing.state,
                billing_country: billing.country,
                billing_zip: billing.zipcode,
                billing_phone: fullphone,
                longitude: "",
                latitude: "",
            };



            let resp = await addBillingInfo(billingInfo)

            if (resp) {


                notify.success('Added billing info succesfully!')
                navigate('/cart')

            }

        } catch (error: any) {
            notify.error(error.message)
        } finally {
            setIsSaving(false)
        }
    }


    return (
        <div className="addbilling animate__animated animate__fadeIn animate__fast">

            <div className='pagetitle'>
                <div className='icon goback' onClick={() => navigate(-1)}></div>
                <div>Billing Information</div>
            </div>


            <div className="inputSection">
                <div className="inputFlex">

                    <div className="inputBox nameOne">
                        <div className="label">First name</div>
                        <input className="input" value={billing.firstname} onChange={(e) => handleInput(e.currentTarget.value, 'firstname')} placeholder="First name"></input>
                    </div>

                    <div className="inputBox nameTwo">
                        <div className="label">Last name</div>
                        <input className="input" value={billing.lastname} onChange={(e) => handleInput(e.currentTarget.value, 'lastname')} placeholder="Last name"></input>
                    </div>


                    <div className="inputBox nameThree">
                        <div className="label">Company Name (Optional)</div>

                        <input className="input" placeholder="Company"></input>
                    </div>


                </div>


                <div className="inputBox">
                    <div className="label">Address</div>
                    <Autocomplete
                        onLoad={(auto) => (autocompleteRef.current = auto)}
                        onPlaceChanged={handlePlaceChanged}
                    >
                        <input ref={inputRef}
                            className="input"
                            placeholder="Enter your address"
                            value={billing.address}
                            onChange={(e) => handleInput(e.currentTarget.value, 'address')}></input>
                    </Autocomplete>
                </div>

                <div className="inputGridFour">

                    <div className="inputBox">
                        <div className="label">Country</div>
                        <input className="input" placeholder="Enter country" value={billing.country} onChange={(e) => handleInput(e.currentTarget.value, 'country')}></input>
                    </div>


                    <div className="inputBox">
                        <div className="label">Region/State</div>
                        <input className="input" placeholder="Enter state" value={billing.state} onChange={(e) => handleInput(e.currentTarget.value, 'state')}></input>
                    </div>


                    <div className="inputBox">
                        <div className="label">City</div>
                        <input className="input" placeholder="Enter City" value={billing.city} onChange={(e) => handleInput(e.currentTarget.value, 'city')}></input>
                    </div>


                    <div className="inputBox">
                        <div className="label">Zip Code</div>
                        <input className="input" placeholder="Enter Zipcode" value={billing.zipcode} onChange={(e) => handleInput(e.currentTarget.value, 'zipcode')}></input>
                    </div>

                </div>


                <div className="inputGridTwo">

                    {/* <div className="inputBox">
                        <div className="label">Email</div>
                        <input className="input"></input>
                    </div> */}


                    <div className="inputBox">
                        <div className="label">Phone</div>

                        <div className="phoneflex">
                            <input className="countrycode" value={billing.countrycode} onChange={(e) => handleDialCode(e.currentTarget.value)} placeholder="+"></input>
                            <input className="input" value={billing.phone} onChange={(e) => handleInput(e.currentTarget.value, 'phone')} placeholder="Enter phone"></input>
                        </div>

                    </div>

                </div>


                <div className='btn-pack'>

                    <LoaderBtn className={'btn full'} text={'Save Info'} clickFunction={saveFunc} isLoading={isSaving}></LoaderBtn>

                </div>

            </div>





            {/* <div className="noteSection">
                <div className="title">Additional Information</div>

                <div className="inputBox">
                    <div className="label">Order Notes (Optional)</div>
                    <textarea className="textarea" placeholder='Notes about your order, e.g. special notes for delivery'></textarea>
                </div>

            </div> */}






        </div>
    )
}


export default AddBilling